export function findInputError(errors: { [key: string]: any }, name: string): { [key: string]: any } {
    const filtered = Object.keys(errors)
        .filter(key => key.includes(name))
        .reduce((cur, key) => {
            return Object.assign(cur, { error: errors[key] })
        }, {})
    return filtered
}
